var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, Utils, CustomElement, Watch, ViewChild, PropertyConverters, Components, Defaults, Debounce } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemPagerElement = class PacemPagerElement extends Components.PacemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'index':
            case 'total':
            case 'pages':
            case 'size':
            case 'mode':
                this._databind();
                break;
        }
    }
    _databind() {
        const repeater = this._repeater;
        if (Utils.isNull(repeater))
            return;
        //
        var datasource = [];
        const size = this.size ?? 10, pages = this.pages ?? 5, total = this.total ?? 0, index = this.index ?? 0, mode = this.mode ?? 'standard';
        if (total > 0) {
            let totpages = Math.ceil(total / size);
            let pageindex = Math.floor(index / size);
            let startpageindex = Math.max(0, Math.ceil(pageindex - pages / 2));
            let endpageindex = Math.min(totpages - 1, startpageindex + pages - 1);
            while (startpageindex > 0 && (1 + endpageindex - startpageindex) < pages) {
                startpageindex--;
            }
            if (mode === 'numeric-only') {
                if (startpageindex > 0) {
                    datasource.push({ caption: (1).toLocaleString(Utils.lang(this)), index: 0, /*first: true,*/ disabled: !( /*start*/pageindex > 0) });
                }
            }
            else {
                // |<
                datasource.push({ caption: '&laquo;', index: 0, first: true, disabled: !( /*start*/pageindex > 0) });
                // <
                datasource.push({ caption: '&lt;', index: size * (pageindex - 1), previous: true, disabled: !(pageindex > 0) });
            }
            // ...
            if (startpageindex > 0 && mode !== 'numeric-only' || startpageindex > 1 && mode === 'numeric-only') {
                datasource.push({ caption: '&hellip;', index: size * (startpageindex - 1) });
            }
            // #
            for (let j = startpageindex; j <= endpageindex; j++) {
                datasource.push({ caption: (j + 1).toLocaleString(Utils.lang(this)), index: j * size });
            }
            // ...
            if (endpageindex < (totpages - 1) && mode !== 'numeric-only' || endpageindex < (totpages - 2) && mode === 'numeric-only') {
                datasource.push({ caption: '&hellip;', index: size * (endpageindex + 1) });
            }
            if (mode === 'numeric-only') {
                if (endpageindex < (totpages - 1)) {
                    datasource.push({ caption: totpages.toLocaleString(Utils.lang(this)), index: size * (totpages - 1), /*last: true,*/ disabled: !( /*end*/pageindex < (totpages - 1)) });
                }
            }
            else {
                // >
                datasource.push({ caption: '&gt;', index: size * (pageindex + 1), next: true, disabled: !(pageindex < (totpages - 1)) });
                // >|
                datasource.push({ caption: '&raquo;', index: size * (totpages - 1), last: true, disabled: !( /*end*/pageindex < (totpages - 1)) });
            }
            // 
            this.index = pageindex * size;
        }
        repeater.datasource = datasource;
    }
};
__decorate([
    ViewChild(P + '-repeater')
], PacemPagerElement.prototype, "_repeater", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemPagerElement.prototype, "index", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number, emit: false })
], PacemPagerElement.prototype, "total", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number, emit: false })
], PacemPagerElement.prototype, "pages", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number, emit: false })
], PacemPagerElement.prototype, "size", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String, emit: false })
], PacemPagerElement.prototype, "mode", void 0);
__decorate([
    Debounce(true)
], PacemPagerElement.prototype, "_databind", null);
PacemPagerElement = __decorate([
    CustomElement({
        tagName: P + '-pager', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater class="${PCSS}-pager"><div class="${PCSS}-buttonset">
<div class="pager-buttons">
    <template>
        <${P}-button class="${PCSS}-page button" on-click=":host.index = ^item.index" disabled="{{ ^item.disabled }}"
    css-class="{{ { 'currentpage': ^item.index === :host.index, 'firstpage buttonset-first': ^item.first, 'previouspage': ^item.previous, 'nextpage': ^item.next, 'lastpage buttonset-last': ^item.last } }}"><${P}-span content="{{ ^item.caption }}"></${P}-span></${P}-button>
    </template>
</div>
</div></${P}-repeater>`
    })
], PacemPagerElement);
export { PacemPagerElement };
